module.exports = __webpack_public_path__ + "media/images/menu/universe_live-095c6bf860db275ad4065b5f3a8f23cb.jpg";